module.exports = __webpack_public_path__ + "static/media/blue.ea85f6fe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/dummy-images/poly/blue.jpeg
// module id = ./src/CSS/assets-minified/dummy-images/poly/blue.jpeg
// module chunks = 0